var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPromoprive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 398,
    height: 73,
    viewBox: "0 0 398 73",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".st0 {\n        fill: #1d1d1b;\n      }\n\n      .st1, .st2 {\n        fill: #e30613;\n      }\n\n      .st1, .st3 {\n        display: none;\n      }"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-8.6 -19)"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "156 105 153 108 154 112 151 109 147 112 149 108 145 105 150 105 151 101 152 105"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "m402 24c0.8-0.4 1.5-0.8 2.1-1.1s1.2-0.7 1.7-1.2c0.8-0.7 1.5-1.5 1.9-2.4 0.5-0.9 0.7-1.8 0.7-2.7 0-1.3-0.5-2.4-1.5-3.2s-2.3-1.2-3.9-1.2-2.2 0.2-3.2 0.6c-1.1 0.4-2 0.9-2.9 1.6-0.6 0.5-1.1 1-1.4 1.4-0.4 0.5-0.8 1.1-1.3 1.8l-6.7 9.8h7.2l7.2-3.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m39 62c0 8.3-8.7 14-19 14h-5v14h-6.4v-43h11c9.9 0 19 6.1 19 14zm-24 9.1h5c6.3 0 12-3.8 12-9.1s-5.8-9.1-12-9.1h-5v18z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m77 88-4.9 3.8-17-17h-4.8v16h-6.4v-43h11c9.2 0 17 5.8 17 13s-5.4 11-11 12zm-21-19c5.6 0 11-3.4 11-8.1s-5-8.1-11-8.1h-5v16h5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m120 70c0 11-6.9 22-20 22s-20-11-20-22 6.9-22 20-22 20 11 20 22zm-20 17c9.6 0 13-9.9 13-17s-3.8-17-13-17-13 9.9-13 17 3.8 17 13 17z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m136 59-6.7 33-6.4-1.2 9.8-43h5.5l12 34 12-34h5.5l9.8 43-6.4 1.2-6.7-33-12 32h-5.5l-12-32z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m222 70c0 11-6.9 22-20 22s-20-11-20-22 6.9-22 20-22 20 11 20 22zm-20 17c9.6 0 13-9.9 13-17s-3.8-17-13-17-13 9.9-13 17 3.8 17 13 17z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m247 48c2.6 0 5.2 0.4 7.7 1.1s4.7 1.8 6.7 3.2 3.5 3 4.6 4.9 1.6 3.9 1.6 6-0.5 4.2-1.6 6c-1.1 1.9-2.6 3.5-4.6 4.9s-4.2 2.4-6.7 3.2c-2.5 0.7-5 1.1-7.7 1.1h-3.1v13h-10v-43zm-3.1 8.5v13h3.1c2.7 0 5.1-0.6 7.1-1.8s3.1-2.8 3.1-4.9-1-3.6-3.1-4.9c-2-1.2-4.4-1.8-7.1-1.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m283 76v15h-10v-43h13c2.5 0 4.9 0.3 7.2 1s4.4 1.7 6.2 3 3.2 2.8 4.3 4.5c1 1.8 1.6 3.6 1.6 5.6s-0.9 4.9-2.5 7.1c-1.7 2.3-4.1 4-7.1 5.1l14 14-8.7 4.2-15-16h-2.7zm0-8.5h3.1c2.3 0 4.4-0.5 6.2-1.6s2.7-2.4 2.7-4.1-0.8-3.2-2.3-4.2-3.7-1.5-6.6-1.5h-3.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m324 48v43h-10v-43z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m365 46 10 2.1-19 42h-9.2l-19-42 10-2.1 13 32 13-32z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "407 91 379 91 379 48 406 48 406 56 389 56 389 64 404 64 404 72 389 72 389 82 407 82"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "m380 31 2.2 0.4c4.8 1 8.6 4.8 9.6 9.6l0.4 2.2 0.4-2.2c1-4.8 4.8-8.6 9.6-9.6l2.2-0.4-2.2-0.4c-4.8-1-8.6-4.8-9.6-9.6l-0.4-2.2-0.4 2.2c-1 4.8-4.8 8.6-9.6 9.6z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m381 19 1.9 0.4c4.2 0.9 6.5 4.4 5.8 8.9l-0.3 2 1.1-2c2.5-4.5 7.2-8 12-8.9l2.2-0.4-1.9-0.4c-4.2-0.9-6.5-4.4-5.8-8.9l0.3-2-1.1 2c-2.5 4.5-7.2 8-12 8.9z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPromoprive);
export default __webpack_public_path__ + "static/media/promoprive.a82dfed52ad0122787a6f88e88e6fcaa.svg";
export { ForwardRef as ReactComponent };